export default __webpack_public_path__ + "static/latest-2-93204791b3b55ab9f9b3704a3c4aab18.webp";